module.exports = __webpack_public_path__ + "img/pre_overdue_dark.1232b3d9.svg";